import {goodEggsLocationIdsToFoodhubSlug} from 'goodeggs-purchase-orders-sdk/foodhub/helpers';
import foodhubs from 'goodeggs-foodhubs';

import {getTimes} from 'local_modules/get_delivery_time';

import Form from './form';

export default ngInject(function(
  $state,
  $rootScope,
  $stateParams,
  Promise,
  foodhub,
  employeeRoles,
  toaster,
  submitPOConfirmationModal,
  confirmActionModal,
  foodhubSelectionModal,
  reconfirmPOConfirmationModal,
  externalUrls,
  $injector,
) {
  this.foodhub = foodhub;
  this.externalUrls = externalUrls;
  const handleError = function(errOrRejection) {
    let left;
    if (errOrRejection == null) {
      return;
    }
    return toaster.fail(
      (left =
        errOrRejection.message != null
          ? errOrRejection.message
          : errOrRejection.data != null
          ? errOrRejection.data.message
          : undefined) != null
        ? left
        : errOrRejection.statusText,
    );
  };

  this.form = new Form($stateParams.poNumber, {
    userCanEdit: employeeRoles.can(
      $rootScope.credentials.google.employee.roles,
      'purchase_orders.edit',
    ),
    foodhub: this.foodhub,
    $injector,
  });
  this.form.loadData().catch(handleError);

  this.save = () =>
    this.form
      .assertValid()
      .then(() => this.form.save())
      .then(() => toaster.success('Purchase order saved.'))
      .catch(handleError);

  this.submit = () =>
    Promise.try(() => this.form.assertValid())
      .then(() =>
        submitPOConfirmationModal.open({form: this.form, vendorEmail: this.form.supplier.email}),
      )
      .then(({autoConfirm}) => this.form.saveAndSubmit({autoConfirm}))
      .catch(handleError);

  this.reconfirm = () =>
    Promise.try(() => this.form.assertValid())
      .then(() =>
        reconfirmPOConfirmationModal.open({form: this.form, vendorEmail: this.form.supplier.email}),
      )
      .then(() => this.form.reconfirm())
      .catch(handleError);

  this.confirm = () =>
    Promise.try(() => confirmActionModal.open('confirm all line items'))
      .then(() => this.form.confirm())
      .catch((err) => {
        this.form.reset();
        return handleError(err);
      });

  this.cancel = () =>
    Promise.try(() => confirmActionModal.open('cancel all line items'))
      .then(() => this.form.cancel())
      .catch((err) => {
        this.form.reset();
        return handleError(err);
      });

  this.clone = () => {
    const supplierDeliverableFoodhubs = this.form.supplier.goodeggsLocationIds.map((id) =>
      foodhubs.bySlug(goodEggsLocationIdsToFoodhubSlug[id]),
    );
    return Promise.try(() =>
      foodhubSelectionModal.open({
        supplierDeliverableFoodhubs,
        foodhub: this.foodhub,
      }),
    )
      .then(({selectedFoodhubSlug}) => {
        this.foodhub = foodhubs.bySlug(selectedFoodhubSlug);
        return this.form.clone({foodhubSlug: this.foodhub.slug});
      })
      .then(({purchaseOrder}) =>
        $state.go('purchase_orders.show', {
          poNumber: purchaseOrder.poNumber,
          foodhubSlug: this.foodhub.slug,
        }),
      )
      .catch((err) => {
        this.form.reset();
        return handleError(err);
      });
  };

  this.edit = () => this.form.edit();

  this.cancelEdit = () =>
    Promise.try(() => {
      if (this.form.purchaseOrder.status === 'new') {
        return confirmActionModal
          .open('cancel this purchase order')
          .then(() => this.form.cancel())
          .then(() =>
            $state.go(
              'purchase_orders.supplier_list',
              {supplierSlug: this.form.supplier.slug},
              {reload: true},
            ),
          );
      }
      return this.form.reset();
    }).catch(handleError);

  this.unconfirm = () =>
    this.form.unconfirm().catch((err) => {
      this.form.reset();
      return handleError(err);
    });

  this.performAction = (actionName) =>
    typeof this[actionName] === 'function' ? this[actionName]() : undefined;

  this.hasUnexpectedStartSellingWhenConfirmedDeliveryDayLineItems = () =>
    getTimes(this.form.purchaseOrderForm.dropoffWindow).end >
      LATEST_REASONABLE_SAME_DAY_DROPOFF_HOUR &&
    this.form.lineItemForms.some(
      (lineItemForm) => lineItemForm.startSellingWhen === 'confirmed (delivery day)',
    );

  return this;
});

const LATEST_REASONABLE_SAME_DAY_DROPOFF_HOUR = 9;
